export const BrandLogo = ({ className = "", invert = false, alt = "DirektLab" }) => (
  <img
    src="/logo-direktlab.png"
    alt={alt}
    className={className}
    style={invert ? { filter: "brightness(0) invert(1)" } : undefined}
    draggable="false"
    loading="eager"
    decoding="async"
  />
);
